<template>
    <div>
        <List
            title="Manage Plans"
            @read="load()"
            write="Add Plan"
            @write="add()"
        >
            <PlanCard v-for="plan in plans" :key="plan._id" :id="plan._id" />
            <template v-slot:modal>
                <Input text="Name" v-model="newPlan.name" />
                <Input text="Nickname" v-model="newPlan.nickname" />
                <Input text="Description" v-model="newPlan.description" />
            </template>
        </List>
    </div>
</template>

<script>
    import { mapState } from 'vuex'

    import List from '@/components/general/list'
    import Input from '@/components/form/input'

    import PlanCard from './card'

    export default {
        data() {
            return {
                newPlan: {}
            }
        },
        methods: {
            load() {
                return this.$store.dispatch('admin/plans/load')
            },
            add() {
                return this.$store
                    .dispatch('admin/plans/add', this.newPlan)
                    .then(() => {
                        this.load()
                        this.newPlan = {}
                        this.$bvToast.toast('Plan added.', {
                            title: 'Success',
                            variant: 'success'
                        })
                    })
            }
        },
        computed: mapState({
            plans: state => state.admin.plans.plans
        }),
        components: {
            PlanCard,
            Input,
            List
        }
    }
</script>